import { message } from 'antd';
import { deleteWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const deleteHealthmetricType = async (id: number, refetch?: () => void) => {
  if (!id) return;

  try {
    const response = await deleteWithCSRF(envApiUrl + '/healthmetrictypes/', {
      headers: {
        id,
      },
    });
    console.log('deleteHealthmetricType: response: ', response);
    message.success('Successfully deleted HealthmetricType');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('deleteHealthmetricType error: ', err.response?.data?.message, err.response);
    message.error(err.response?.data?.message || 'Failed to delete HealthmetricType');
  }
};
